import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';
// Self-hosted Cairo variable font (Arabic + Latin + Latin-ext subsets, weights 200-1000,
// font-display: swap) — 12-reskin-spec.md §6/D-UI8. Loaded once here so both the `ar` and `en`
// font stacks in tokens.css resolve to the same physical file, no Google Fonts CDN dependency.
import '@fontsource-variable/cairo';
import '@/styles/global.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
